var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":!_vm.xSmall,"x-small":_vm.xSmall,"label":"","outlined":"","color":_vm.color,"data-test":"supervision-level"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }